(function () {
  "use strict";

  // Script may appear both in layout (for Quick view) and in product markup.
  // Running twice would double-bind popstate / quickview listeners.
  if (window.__pmVariantPickerLoaded) return;
  window.__pmVariantPickerLoaded = true;

  var API_VERSION = "2025-01";
  var PRODUCT_LIMIT = 250;
  var VARIANT_LIMIT = 250;
  var PICKER_COLLECTION_PRODUCTS_QUERY = `query PickerCollectionProducts($handle: String!, $first: Int!, $after: String) {
  collection(handle: $handle) {
    handle
    products(first: $first, after: $after) {
      nodes {
        id
        handle
        availableForSale
        onlineStoreUrl
        variants(first: ${VARIANT_LIMIT}) {
          nodes {
            id
            sku
            availableForSale
            selectedOptions {
              name
              value
            }
            metafield(namespace: "custom", key: "pm_color_group") {
              value
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}`;

  // DPT16MGW / WPT16PODB / ANY16MGW → { size: 16, colorCode: "MGW"|"PODB" }.
  // Strips any letter prefix before the size digits; colorCode is prefix-agnostic.
  function parseSku(sku) {
    if (!sku) return null;

    var match = String(sku).match(/^([A-Za-z]+)(\d+)([A-Za-z]+)$/i);

    if (!match) return null;

    return {
      size: parseInt(match[2], 10),
      colorCode: match[3].toUpperCase(),
    };
  }

  // Storefront API returns GIDs like "gid://shopify/ProductVariant/44308890878209".
  // Product URLs need the numeric part: ?variant=44308890878209
  function toNumericId(gid) {
    if (!gid) return null;

    var parts = String(gid).split("/");
    return parts[parts.length - 1] || null;
  }

  function getProductSize(product) {
    var variants = (product.variants && product.variants.nodes) || [];

    for (var i = 0; i < variants.length; i++) {
      var parsed = parseSku(variants[i].sku);
      if (parsed) return parsed.size;
    }

    return null;
  }

  // Maps colorCode → variant for ONE product/size.
  //
  // Example after Storefront fetch of collection [16oz, 26oz]:
  //   DPT16MGW → MGW: { id: "111111111", name: "Ocean Blue", … }  // id of 16oz variant
  //   DPT26MGW → MGW: { id: "222222111", name: "Ocean Blue", … }  // id of 26oz variant
  //
  // Same colorCode ("MGW") links siblings; variant ids are always product-specific.
  // These maps are built once at init — size click only looks up the target size's id.
  function buildVariantsByColor(product) {
    var variantsByColor = {};
    var variants = (product.variants && product.variants.nodes) || [];

    console.log(
      "[variant-picker] All variants for product:",
      product.handle,
      variants,
    );

    variants.forEach(function (variant) {
      var parsed = parseSku(variant.sku);

      if (!parsed || !parsed.colorCode) return;
      if (variantsByColor[parsed.colorCode]) return;

      variantsByColor[parsed.colorCode] = {
        id: toNumericId(variant.id),
        gid: variant.id,
        available: !!variant.availableForSale,
        name: getColorOptionName(variant.selectedOptions),
        colorGroup:
          variant.metafield && variant.metafield.value
            ? String(variant.metafield.value).trim() || null
            : null,
      };
    });

    return variantsByColor;
  }

  function getColorOptionName(selectedOptions) {
    if (!selectedOptions || !selectedOptions.length) return null;

    for (var i = 0; i < selectedOptions.length; i++) {
      var optionName = (selectedOptions[i].name || "").toLowerCase();

      if (
        optionName.indexOf("color") !== -1 ||
        optionName.indexOf("colour") !== -1
      ) {
        return selectedOptions[i].value;
      }
    }

    if (selectedOptions.length === 1) {
      return selectedOptions[0].value;
    }

    return null;
  }

  // One entry per size sibling in the metafield collection.
  // Each entry carries variantsByColor so size switch can resolve ?variant= without another API call.
  function buildSizeOptions(products) {
    var sizesByValue = {};

    products.forEach(function (product) {
      var size = getProductSize(product);

      if (size === null || sizesByValue[size]) return;

      sizesByValue[size] = {
        value: size,
        handle: product.handle,
        url: product.onlineStoreUrl || "/products/" + product.handle,
        available: !!product.availableForSale,
        variantsByColor: buildVariantsByColor(product),
      };
    });

    return Object.keys(sizesByValue)
      .map(function (size) {
        return parseInt(size, 10);
      })
      .sort(function (a, b) {
        return a - b;
      })
      .map(function (size) {
        return sizesByValue[size];
      });
  }

  // Build URL for size switch, preserving color via colorCode → target variant id.
  //
  // Example: on 26oz / MGW, click 16oz
  //   config.currentColorCode = "MGW"
  //   sizeOption = sizes entry for 16 (already has variantsByColor from collection fetch)
  //   sizeOption.variantsByColor["MGW"].id = "111111111"  // 16oz Ocean Blue — known at init
  //   → "/products/16oz-…?variant=111111111"
  //
  // If MGW is missing on the target size → first available variant on that size.
  function getFirstAvailableVariant(sizeOption) {
    if (!sizeOption || !sizeOption.variantsByColor) return null;

    var colorCodes = Object.keys(sizeOption.variantsByColor).sort();

    for (var i = 0; i < colorCodes.length; i++) {
      var variant = sizeOption.variantsByColor[colorCodes[i]];
      if (variant && variant.available && variant.id) {
        return variant;
      }
    }

    for (var j = 0; j < colorCodes.length; j++) {
      var fallback = sizeOption.variantsByColor[colorCodes[j]];
      if (fallback && fallback.id) {
        return fallback;
      }
    }

    return null;
  }

  function getVariantIdForSize(sizeOption, colorCode) {
    if (!sizeOption) return null;

    var colorVariant =
      colorCode && sizeOption.variantsByColor
        ? sizeOption.variantsByColor[colorCode]
        : null;

    if (colorVariant && colorVariant.id) {
      return colorVariant.id;
    }

    var firstAvailable = getFirstAvailableVariant(sizeOption);
    return firstAvailable && firstAvailable.id ? firstAvailable.id : null;
  }

  function buildSizeUrl(sizeOption, colorCode) {
    if (!sizeOption || !sizeOption.url) return null;

    var url = sizeOption.url;
    var variantId = getVariantIdForSize(sizeOption, colorCode);

    if (variantId) {
      url += (url.indexOf("?") === -1 ? "?" : "&") + "variant=" + variantId;
    }

    return url;
  }

  // Keep fetch on current origin (important for shopify theme dev / localhost).
  function toSameOriginPath(url) {
    if (!url) return null;

    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      try {
        var parsed = new URL(url);
        return parsed.pathname + parsed.search;
      } catch (e) {
        return url;
      }
    }

    return url;
  }

  // Size switch: fetch full product page and soft-replace #MainContent
  // (product + reviews + recommendations + other body sections).
  function fetchMainContent(cleanUrl) {
    var fetchUrl = toSameOriginPath(cleanUrl);
    if (!fetchUrl) {
      return Promise.reject(new Error("fetchMainContent: missing url"));
    }

    return fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("MainContent fetch failed: " + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newMain = doc.querySelector("#MainContent");

        if (!newMain) {
          throw new Error("MainContent not found in response");
        }

        return newMain;
      });
  }

  // Unload theme section instances whose containers live under #MainContent
  // so Flickity / listeners do not leak across the swap.
  function unloadMainContentSections(mainEl) {
    if (
      !mainEl ||
      !window.theme ||
      !theme.sections ||
      !theme.sections.instances
    ) {
      return;
    }

    var instances = theme.sections.instances.slice();
    for (var i = 0; i < instances.length; i++) {
      var instance = instances[i];
      if (!instance || !instance.container) continue;
      if (!mainEl.contains(instance.container)) continue;

      if (typeof instance.onUnload === "function") {
        try {
          instance.onUnload();
        } catch (e) {
          console.warn("[pm-size-color] section unload failed", e);
        }
      }

      if (typeof theme.sections._removeInstance === "function" && instance.id) {
        theme.sections._removeInstance(instance.id);
      }
    }
  }

  function replaceMainContent(newMain) {
    var currentMain = document.getElementById("MainContent");

    if (!currentMain) {
      throw new Error("Current MainContent not found in DOM");
    }

    unloadMainContentSections(currentMain);
    currentMain.replaceChildren.apply(
      currentMain,
      Array.prototype.slice.call(newMain.childNodes),
    );
    return currentMain;
  }

  function updateHistoryUrl(cleanUrl) {
    history.pushState({}, "", toSameOriginPath(cleanUrl));
  }

  function isModalContext(root) {
    if (!root || !root.closest) return false;
    var section = root.closest("[data-modal]");
    return !!(section && section.getAttribute("data-modal") === "true");
  }

  // On first load without ?variant=, sync URL to the rendered variant (replaceState).
  // Skip in Quick view — modal must not rewrite the host page URL (e.g. collection).
  function ensureVariantInUrl(variantId, root) {
    if (!variantId || !history.replaceState) return;
    if (isModalContext(root)) return;

    var params = new URLSearchParams(window.location.search);
    if (params.get("variant")) return;

    params.set("variant", String(variantId));
    var newUrl =
      window.location.pathname +
      (params.toString() ? "?" + params.toString() : "");
    history.replaceState({ path: newUrl }, "", newUrl);
  }

  var isSwitchingSize = false;

  function fallbackRedirect(cleanUrl, error) {
    console.error(
      "[pm-size-color] MainContent switch failed, fallback redirect",
      error,
    );
    window.location.href = toSameOriginPath(cleanUrl);
  }

  // Impulse theme.Product on the new MainContent markup
  function reinitThemeProduct(mainEl) {
    if (!mainEl || !window.theme || !theme.sections || !theme.Product) {
      console.warn("[pm-size-color] theme.Product unavailable");
      return;
    }

    var productEl = mainEl.querySelector('[data-section-type="product"]');
    if (!productEl) {
      console.warn("[pm-size-color] product container not found");
      return;
    }

    // register(..., scope) finds [data-section-type=product] and recreates instance
    theme.sections.register("product", theme.Product, mainEl);

    // Other section types under MainContent (recently-viewed, testimonials, …)
    // that have registered constructors — only top-level containers to avoid
    // double-init of nested data-section-id nodes.
    var types = [
      "recently-viewed",
      "testimonials",
      "collection-grid",
      "promo-grid",
      "text-with-icons",
      "video-section",
      "background-image",
    ];
    for (var i = 0; i < types.length; i++) {
      var type = types[i];
      var ctor =
        theme.sections.constructors && theme.sections.constructors[type];
      if (ctor) {
        theme.sections.register(type, ctor, mainEl);
      }
    }

    if (typeof theme.initGlobals === "function") {
      theme.initGlobals();
    }
  }

  // Scripts inserted via DOMParser/replaceWith do NOT run. App blocks (Pirani
  // Customizer) need them: inline sets PCA_BUILDER / setSelectedSkuAndOpenBuilder,
  // pca-builder.js mounts React into #pca-builder-app and sets window.openBuilder.
  // Without remount, Customize click calls setSelectedSku… but openBuilder is gone
  // (React cleanup on unmount sets window.openBuilder = undefined).
  function reinitSectionScripts(sectionEl) {
    if (!sectionEl) return Promise.resolve();

    var scripts = Array.prototype.slice.call(
      sectionEl.querySelectorAll("script"),
    );
    var seenExternal = {};

    return new Promise(function (resolve) {
      function next(i) {
        if (i >= scripts.length) {
          resolve();
          return;
        }

        var oldScript = scripts[i];
        var type = (oldScript.getAttribute("type") || "").toLowerCase();
        var src = oldScript.getAttribute("src");

        // Skip non-JS (e.g. application/json product data)
        if (type && type.indexOf("javascript") === -1 && type !== "module") {
          next(i + 1);
          return;
        }

        // Skip our picker — already in memory; re-running would double popstate
        if (src && src.indexOf("variant-picker") !== -1) {
          next(i + 1);
          return;
        }

        if (src) {
          var normalized = src.split("?")[0];
          if (seenExternal[normalized]) {
            next(i + 1);
            return;
          }
          seenExternal[normalized] = true;
        }

        var newScript = document.createElement("script");
        if (type) newScript.type = oldScript.type;

        if (src) {
          // Cache-bust so the browser re-executes and React remounts
          var sep = src.indexOf("?") === -1 ? "?" : "&";
          newScript.src = src + sep + "_pm_reinit=" + Date.now();
          newScript.onload = function () {
            next(i + 1);
          };
          newScript.onerror = function () {
            next(i + 1);
          };
          oldScript.parentNode.replaceChild(newScript, oldScript);
        } else {
          newScript.textContent = oldScript.textContent;
          // Some app inline scripts re-declare top-level `const`/`let`
          // (e.g. Pirani Customizer's `const PCA_PRODUCT_VARIANTS = …`),
          // which throws a redeclaration SyntaxError on re-exec. Soft-continue
          // so one bad script does not abort the rest of the remount chain
          // (pca-builder.js, appProducts, …). Fresh data still comes from the
          // window.* assignment scripts that ran before it.
          try {
            oldScript.parentNode.replaceChild(newScript, oldScript);
          } catch (e) {
            console.warn(
              "[pm-size-color] inline script re-exec failed (continuing)",
              e,
            );
          }
          next(i + 1);
        }
      }

      next(0);
    });
  }

  // Pirani Customizer's setSelectedSkuAndOpenBuilder() closes over a top-level
  // `const PCA_PRODUCT_VARIANTS` captured on FIRST page load, so after a soft
  // size swap it still resolves the previous product (and its inline script
  // cannot be re-executed — the const redeclaration throws). Rebind the global
  // the Customize button calls to read the LIVE window.PCA_PRODUCT_VARIANTS,
  // which the app's window.* data scripts refresh to the new product on swap.
  // Mirrors the app's own logic (find by ?variant id → fallback to first).
  function rebindCustomizerBuilder() {
    if (!Array.isArray(window.PCA_PRODUCT_VARIANTS)) return;

    window.setSelectedSkuAndOpenBuilder = function () {
      var variants = window.PCA_PRODUCT_VARIANTS || [];
      var params = new URLSearchParams(window.location.search);
      var variantId = params.get("variant");
      var matched = null;

      if (variantId) {
        matched = variants.find(function (variant) {
          return variant.id === Number(variantId);
        });
      }

      if (!matched) matched = variants[0];

      if (matched && window.PCA_BUILDER) {
        window.PCA_BUILDER.selectedSku = matched.sku;
      }

      if (typeof window.openBuilder === "function") {
        window.openBuilder();
      }
    };
  }

  // Shared pipeline: fetch full page → replace #MainContent → pushState → reinit
  function loadProductByUrl(cleanUrl, options) {
    var opts = options || {};
    var shouldPushState = opts.pushState !== false;

    if (!cleanUrl || !toSameOriginPath(cleanUrl)) {
      return Promise.reject(new Error("loadProductByUrl: missing url"));
    }

    return fetchMainContent(cleanUrl).then(function (newMain) {
      var mainEl = replaceMainContent(newMain);

      if (shouldPushState) {
        updateHistoryUrl(cleanUrl);
      }

      window.scrollTo(0, 0);

      // Theme first, then our picker, then app scripts (Customizer openBuilder)
      reinitThemeProduct(mainEl);

      var pickerRoot = mainEl.querySelector("[data-pm-size-color]");
      if (pickerRoot) {
        initPicker(pickerRoot);
      }

      return reinitSectionScripts(mainEl).then(function () {
        rebindCustomizerBuilder();
        isSwitchingSize = false;
        return mainEl;
      });
    });
  }

  // Size click: always another product → full #MainContent soft swap.
  // Color is preserved by passing config.currentColorCode into buildSizeUrl
  // (lookup target size's variantsByColor[colorCode].id — see buildSizeUrl comment).
  function switchProductSize(root, size, config) {
    var cleanUrl = buildSizeUrl(size, config.currentColorCode);

    if (!cleanUrl) {
      console.error("[pm-size-color] switchProductSize: missing url", {
        cleanUrl: cleanUrl,
      });
      return;
    }

    if (String(size.value) === String(config.currentSize)) return;
    if (isSwitchingSize) return;

    // Quick view cannot SPA-swap #MainContent — go to the sibling product page.
    if (isModalContext(root)) {
      window.location.href = toSameOriginPath(cleanUrl);
      return;
    }

    isSwitchingSize = true;

    loadProductByUrl(cleanUrl, { pushState: true }).catch(function (error) {
      isSwitchingSize = false;
      fallbackRedirect(cleanUrl, error);
    });
  }

  // Browser Back / Forward — URL already changed, fetch without pushState
  function onSizeColorPopState() {
    var root = document.querySelector("[data-pm-size-color]");
    if (!root) {
      window.location.reload();
      return;
    }

    var cleanUrl = window.location.pathname + window.location.search;

    if (isSwitchingSize) return;

    isSwitchingSize = true;

    loadProductByUrl(cleanUrl, { pushState: false }).catch(function (error) {
      isSwitchingSize = false;
      console.error("[pm-size-color] popstate failed, reloading", error);
      window.location.reload();
    });
  }

  window.addEventListener("popstate", onSizeColorPopState);

  function storefrontRequest(token, shopDomain, query, variables) {
    return fetch(
      "https://" + shopDomain + "/api/" + API_VERSION + "/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token,
        },
        body: JSON.stringify({
          query: query,
          variables: variables,
        }),
      },
    ).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.errors) {
          throw new Error(JSON.stringify(json.errors || json));
        }

        return json.data;
      });
    });
  }

  // Products in the metafield collection (size siblings only).
  // Pages of PRODUCT_LIMIT until hasNextPage is false. If page 2+ fails,
  // return products already collected so the picker can still render.
  function fetchCollectionProducts(token, shopDomain, collectionHandle) {
    var allProducts = [];
    var after = null;

    function fetchPage() {
      return storefrontRequest(
        token,
        shopDomain,
        PICKER_COLLECTION_PRODUCTS_QUERY,
        {
          first: PRODUCT_LIMIT,
          handle: collectionHandle,
          after: after,
        },
      )
        .then(function (data) {
          if (!data.collection) {
            throw new Error(
              "Collection not found or not published to Storefront: " +
                collectionHandle,
            );
          }

          var connection = data.collection.products || {};
          var nodes = connection.nodes || [];
          var pageInfo = connection.pageInfo || {};

          allProducts = allProducts.concat(nodes);

          if (pageInfo.hasNextPage && pageInfo.endCursor) {
            after = pageInfo.endCursor;
            return fetchPage();
          }

          return allProducts;
        })
        .catch(function (error) {
          if (allProducts.length > 0) {
            console.warn(
              "[pm-size-color] collection page fetch failed, using partial results",
              {
                loaded: allProducts.length,
                error: error,
              },
            );
            return allProducts;
          }

          throw error;
        });
    }

    return fetchPage();
  }

  function buildPickerConfig(products, currentContext) {
    var sizeOptions = buildSizeOptions(products);
    var currentParsed = parseSku(currentContext.variantSku);

    // currentColorCode comes from current page SKU (e.g. DPT26MGW → "MGW").
    // On color click it is updated in renderPickerUi; on size click it is passed to buildSizeUrl.
    return {
      currentSize: currentParsed ? currentParsed.size : null,
      currentColorCode: currentParsed ? currentParsed.colorCode : null,
      currentProductHandle: currentContext.productHandle || null,
      sizes: sizeOptions,
    };
  }

  // Match Shopify Liquid | handle / | handleize for swatch file names.
  // Strip diacritics first (Limón → limon), otherwise ó becomes a hyphen (lim-n).
  function stripDiacritics(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function handleize(value) {
    return stripDiacritics(value)
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function normalizeColorNameForMatch(name) {
    return stripDiacritics(name).trim().toLowerCase();
  }

  function parseColorSortOrder(root) {
    var el = root && root.querySelector("[data-pm-color-sort-order]");
    if (!el || !el.textContent.trim()) return null;

    try {
      var parsed = JSON.parse(el.textContent.trim());
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? parsed
        : null;
    } catch (e) {
      console.warn("[pm-size-color] Invalid color sort order JSON", e);
      return null;
    }
  }

  // Display form: "EARTH" / "earth" → "Earth"
  function formatGroupName(name) {
    var s = String(name || "").trim();
    if (!s) return s;
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }

  function sortColorsByName(a, b) {
    return (a.name || a.value).localeCompare(b.name || b.value);
  }

  function getSortList(sortOrder, groupName) {
    if (!sortOrder) return null;

    var key = Object.keys(sortOrder).find(function (k) {
      return formatGroupName(k) === groupName;
    });

    return key && Array.isArray(sortOrder[key]) ? sortOrder[key] : null;
  }

  function sortColorsByOrder(colors, orderList) {
    if (!colors.length) return colors;
    if (!orderList || !orderList.length) {
      return colors.slice().sort(sortColorsByName);
    }

    var ordered = [];
    var used = {};

    orderList.forEach(function (configName) {
      var target = normalizeColorNameForMatch(configName);

      colors.forEach(function (color) {
        if (used[color.value]) return;
        if (normalizeColorNameForMatch(color.name) === target) {
          ordered.push(color);
          used[color.value] = true;
        }
      });
    });

    return ordered.concat(
      colors
        .filter(function (color) {
          return !used[color.value];
        })
        .sort(sortColorsByName),
    );
  }

  function flattenSortList(sortOrder) {
    if (!sortOrder) return null;

    return Object.keys(sortOrder).reduce(function (list, key) {
      return Array.isArray(sortOrder[key])
        ? list.concat(sortOrder[key])
        : list;
    }, []);
  }

  // Colors for the CURRENT size/product only — do not merge sibling sizes.
  // OOS on this product stays visible (theme .disabled); other sizes' colors are omitted.
  function getAllColors(config) {
    var currentSizeOption = config.sizes.find(function (size) {
      return size.value === config.currentSize;
    });

    if (!currentSizeOption || !currentSizeOption.variantsByColor) {
      return [];
    }

    return Object.keys(currentSizeOption.variantsByColor).map(
      function (colorCode) {
        var variant = currentSizeOption.variantsByColor[colorCode];
        var name = variant.name || colorCode;
        var available = !!variant.available;

        return {
          value: colorCode,
          name: name,
          handle: handleize(name),
          fallbackColor: handleize(String(name).split(" ").pop()),
          colorGroup: variant.colorGroup || null,
          availableOnCurrentSize: available,
          available: available,
          selectable: true,
          variantId: variant.id,
        };
      },
    );
  }

  function buildColorGroups(colors, sortOrder) {
    if (!colors.length) return null;
    if (!colors.some(function (color) { return color.colorGroup; })) return null;

    var byName = {};
    var other = [];

    colors.forEach(function (color) {
      var groupName = color.colorGroup ? formatGroupName(color.colorGroup) : "";

      if (!groupName) {
        other.push(color);
        return;
      }

      (byName[groupName] = byName[groupName] || []).push(color);
    });

    Object.keys(byName).forEach(function (name) {
      byName[name] = sortColorsByOrder(byName[name], getSortList(sortOrder, name));
    });
    other = sortColorsByOrder(other, null);

    var groups = [];
    var seen = {};

    (sortOrder ? Object.keys(sortOrder) : []).forEach(function (key) {
      var name = formatGroupName(key);
      if (!byName[name]) return;
      groups.push({ name: name, colors: byName[name] });
      seen[name] = true;
    });

    Object.keys(byName)
      .sort()
      .forEach(function (name) {
        if (!seen[name]) {
          groups.push({ name: name, colors: byName[name] });
        }
      });

    if (other.length) {
      groups.push({ name: "Other", colors: other });
    }

    return groups;
  }

  function createEl(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }

  // Shopify Files: size-10oz.png → size-10oz_120x.png (same CDN base as color swatches)
  function buildSizeImageUrl(filesBase, sizeValue) {
    if (!filesBase || sizeValue == null) return "";
    return filesBase + "size-" + sizeValue + "oz_120x.png";
  }

  function renderSizeRow(root, config, onSizeClick) {
    var filesBase = root.dataset.swatchFilesBase || "";
    var wrapper = createEl("div", "variant-wrapper js pm-size-color__row");
    wrapper.setAttribute("data-type", "button");

    var label = createEl("label", "variant__label");
    label.appendChild(document.createTextNode("Size"));
    var labelInfo = createEl("span", "variant__label-info");
    labelInfo.innerHTML = " &mdash; ";
    var labelValue = createEl("span", "");
    labelValue.setAttribute("data-variant-size-label", "");
    if (config.currentSize != null) {
      labelValue.textContent = config.currentSize + "oz";
    }
    labelInfo.appendChild(labelValue);
    label.appendChild(labelInfo);
    wrapper.appendChild(label);

    var options = createEl("div", "pm-size-color__options variant-input-wrap");
    var buttons = [];

    config.sizes.forEach(function (size) {
      var sizeLabel = size.value + "oz";
      var wrap = createEl("div", "pm-size-color__option");
      var btn = createEl("button", "pm-size-color__size");
      btn.type = "button";
      btn.dataset.size = String(size.value);
      btn.setAttribute("aria-label", sizeLabel);

      var imageUrl = buildSizeImageUrl(filesBase, size.value);
      if (imageUrl) {
        var img = document.createElement("img");
        img.className = "pm-size-color__size-image";
        img.src = imageUrl;
        img.alt = "";
        img.width = 54;
        img.height = 54;
        img.loading = "lazy";
        img.decoding = "async";
        img.addEventListener("error", function () {
          img.hidden = true;
        });
        btn.appendChild(img);
      }

      var text = createEl("span", "pm-size-color__size-label", sizeLabel);
      btn.appendChild(text);

      if (size.value === config.currentSize) {
        btn.classList.add("is-selected");
        btn.setAttribute("aria-current", "true");
      }

      buttons.push({ btn: btn, size: size });

      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        if (size.value === config.currentSize) return;
        onSizeClick(size);
      });

      wrap.appendChild(btn);
      options.appendChild(wrap);
    });

    // Re-apply availability against the current color; called on init and on
    // color change so a color missing on a size disables that size live.
    function updateAvailability() {
      buttons.forEach(function (entry) {
        applySizeAvailability(entry.btn, entry.size, config);
      });
    }

    updateAvailability();
    wrapper.pmUpdateSizeAvailability = updateAvailability;

    wrapper.appendChild(options);
    return wrapper;
  }

  // Availability relative to the currently selected color:
  // - color missing on this size → disabled (cannot switch)
  // - color exists but sold out → strikethrough, still selectable
  // - no color context → fall back to product-level availability
  function applySizeAvailability(btn, size, config) {
    btn.classList.remove("is-unavailable", "is-sold-out");
    btn.disabled = false;

    var colorVariant =
      config.currentColorCode && size.variantsByColor
        ? size.variantsByColor[config.currentColorCode]
        : null;

    if (config.currentColorCode) {
      if (!colorVariant) {
        btn.classList.add("is-unavailable");
        btn.disabled = true;
      } else if (!colorVariant.available) {
        btn.classList.add("is-sold-out");
      }
    } else if (!size.available) {
      btn.classList.add("is-unavailable");
      btn.disabled = true;
    }
  }

  function renderColorRow(root, config, colors, colorGroups, onColorClick) {
    var formId = root.dataset.formId || "";
    var sectionId = root.dataset.sectionId || "";
    var productId = root.dataset.productId || "";
    var optionName = "Color";
    var optionPosition = "1";
    var optionIndex = "0";
    var filesBase = root.dataset.swatchFilesBase || "";
    var optionKey = "option" + optionPosition;
    var optionHandle = handleize(optionName);

    var wrapper = createEl("div", "variant-wrapper js pm-size-color__row");
    wrapper.setAttribute("data-type", "button");

    var selectedColor = colors.find(function (color) {
      return color.value === config.currentColorCode;
    });

    var label = createEl("label", "variant__label");
    label.appendChild(document.createTextNode(optionName));
    var labelInfo = createEl("span", "variant__label-info");
    labelInfo.innerHTML = " &mdash; ";
    var labelValue = createEl("span", "");
    labelValue.setAttribute("data-variant-color-label", "");
    labelValue.setAttribute("data-index", optionIndex);
    labelValue.setAttribute("data-option-index", optionIndex);
    labelValue.textContent =
      (selectedColor && selectedColor.name) || config.currentColorCode || "";
    labelInfo.appendChild(labelValue);
    label.appendChild(labelInfo);
    wrapper.appendChild(label);

    var fieldset = createEl("fieldset", "variant-input-wrap");
    fieldset.name = optionName;
    fieldset.setAttribute("data-index", optionKey);
    fieldset.setAttribute("data-handle", optionHandle);
    fieldset.id =
      "ProductSelect-" + sectionId + "-" + productId + "-option-" + optionIndex;

    var legend = createEl("legend", "hide", optionName);
    fieldset.appendChild(legend);

    function appendColorSwatch(container, color) {
      var colorName = color.name || color.value;
      var colorHandle = color.handle;
      // Match theme id encoding: url_encode → spaces become +
      var encodedValue = encodeURIComponent(colorName).replace(/%20/g, "+");
      var inputId =
        "ProductSelect-" +
        sectionId +
        "-" +
        productId +
        "-option-" +
        optionHandle +
        "-" +
        encodedValue;

      var variantInput = createEl("div", "variant-input");
      variantInput.setAttribute("data-index", optionKey);
      variantInput.setAttribute("data-value", colorName);

      var input = document.createElement("input");
      input.type = "radio";
      // Display group only — real form radios stay in [data-default-variant-picker]
      // so theme.Variants (bound on page load) still receives change events.
      input.name = "pm-size-color-" + optionName;
      input.value = colorName;
      input.id = inputId;
      input.setAttribute("data-index", optionKey);
      input.setAttribute("data-color-name", colorName);
      input.setAttribute("data-color-index", optionIndex);
      input.setAttribute("data-color-code", color.value);
      input.className = "variant__input--color-swatch";

      if (color.value === config.currentColorCode) {
        input.checked = true;
      }

      var swatchLabel = document.createElement("label");
      swatchLabel.htmlFor = inputId;
      swatchLabel.className =
        "variant__button-label color-swatch color-swatch--" + colorHandle;

      // OOS on this product: theme .disabled (strikethrough), still selectable
      if (!color.availableOnCurrentSize) {
        input.classList.add("disabled");
        swatchLabel.classList.add("disabled");
      }

      var fallback = color.fallbackColor || colorHandle;
      var imageUrl = filesBase ? filesBase + colorHandle + "_50x50.png" : "";
      var style =
        "background-color: " +
        fallback +
        ";" +
        (imageUrl ? "  background-image: url(" + imageUrl + ");" : "");
      swatchLabel.setAttribute("style", style);
      swatchLabel.textContent = colorName;

      input.addEventListener("change", function () {
        if (!input.checked || !color.selectable) return;
        onColorClick(color, labelValue);
      });

      variantInput.appendChild(input);
      variantInput.appendChild(swatchLabel);
      container.appendChild(variantInput);
    }

    if (!colorGroups) {
      colors.forEach(function (color) {
        appendColorSwatch(fieldset, color);
      });
    } else {
      fieldset.classList.add("pm-size-color__swatches--grouped");
      colorGroups.forEach(function (group) {
        var groupEl = createEl("div", "pm-size-color__group");
        groupEl.appendChild(
          createEl("div", "pm-size-color__group-label", group.name),
        );
        var swatches = createEl("div", "pm-size-color__group-swatches");
        group.colors.forEach(function (color) {
          appendColorSwatch(swatches, color);
        });
        groupEl.appendChild(swatches);
        fieldset.appendChild(groupEl);
      });
    }

    wrapper.appendChild(fieldset);
    return wrapper;
  }

  // Mobile sticky bar still expects a .variant__label (pir.css). Keep picker
  // row labels in-flow; this clone is what sits in the footer.
  function renderStickySelectionLabel(config, colors) {
    var selectedColor = colors.find(function (color) {
      return color.value === config.currentColorCode;
    });
    var colorName =
      (selectedColor && selectedColor.name) || config.currentColorCode || "";
    var sizeName = config.currentSize != null ? config.currentSize + "oz" : "";

    var wrapper = createEl(
      "div",
      "variant-wrapper pm-size-color__sticky-label",
    );
    wrapper.setAttribute("aria-hidden", "true");

    var label = createEl("label", "variant__label");

    var colorLine = createEl("span", "pm-size-color__sticky-line");
    colorLine.appendChild(document.createTextNode("Color"));
    var colorInfo = createEl("span", "variant__label-info");
    colorInfo.innerHTML = " &mdash; ";
    var colorValue = createEl("span", "");
    colorValue.setAttribute("data-pm-sticky-color-label", "");
    colorValue.textContent = colorName;
    colorInfo.appendChild(colorValue);
    colorLine.appendChild(colorInfo);
    label.appendChild(colorLine);

    if (sizeName) {
      var sizeLine = createEl("span", "pm-size-color__sticky-line");
      sizeLine.appendChild(document.createTextNode("Size"));
      var sizeInfo = createEl("span", "variant__label-info");
      sizeInfo.innerHTML = " &mdash; ";
      var sizeValue = createEl("span", "");
      sizeValue.setAttribute("data-pm-sticky-size-label", "");
      sizeValue.textContent = sizeName;
      sizeInfo.appendChild(sizeValue);
      sizeLine.appendChild(sizeInfo);
      label.appendChild(sizeLine);
    }

    wrapper.appendChild(label);
    return wrapper;
  }

  function syncThemeColorRadio(colorName, root) {
    if (!colorName) return false;

    var scope =
      (root && root.closest && root.closest(".product-block")) || document;
    var inputs = scope.querySelectorAll(
      "[data-default-variant-picker] input[data-variant-input][data-color-name]",
    );

    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute("data-color-name") === colorName) {
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function renderPickerUi(root, config) {
    var ui = root.querySelector("[data-pm-size-color-ui]");
    var loading = root.querySelector("[data-pm-size-color-loading]");
    if (!ui) return;

    ui.innerHTML = "";

    var sortOrder = parseColorSortOrder(root);
    var colors = getAllColors(config);
    var colorGroups = buildColorGroups(colors, sortOrder);

    if (!colorGroups && sortOrder) {
      colors = sortColorsByOrder(colors, flattenSortList(sortOrder));
    }

    var sizeRow = null;
    if (config.sizes.length > 1) {
      sizeRow = renderSizeRow(root, config, function (size) {
        switchProductSize(root, size, config);
      });
      ui.appendChild(sizeRow);
    }

    ui.appendChild(
      renderColorRow(
        root,
        config,
        colors,
        colorGroups,
        function (color, labelValueEl) {
          var synced = syncThemeColorRadio(color.name, root);
          var colorText = color.name || color.value;

          config.currentColorCode = color.value;
          if (labelValueEl) {
            labelValueEl.textContent = colorText;
          }

          if (sizeRow && sizeRow.pmUpdateSizeAvailability) {
            sizeRow.pmUpdateSizeAvailability();
          }

          var stickyColorLabel = ui.querySelector(
            "[data-pm-sticky-color-label]",
          );
          if (stickyColorLabel) {
            stickyColorLabel.textContent = colorText;
          }

          if (!synced && color.variantId && !isModalContext(root)) {
            window.location.href =
              window.location.pathname + "?variant=" + color.variantId;
          }
        },
      ),
    );

    ui.appendChild(renderStickySelectionLabel(config, colors));

    if (loading) loading.hidden = true;
    ui.hidden = false;
  }

  function initPicker(root) {
    if (!root || root.dataset.pmSizeColorInitialized === "true") return;

    var token = root.dataset.storefrontToken;
    var shopDomain = root.dataset.shopDomain;
    var collectionHandle = root.dataset.collectionHandle;
    var currentContext = {
      productHandle: root.dataset.currentProductHandle || null,
      variantSku: root.dataset.currentVariantSku || null,
    };

    if (!token || !shopDomain || !collectionHandle) return;

    root.dataset.pmSizeColorInitialized = "true";
    ensureVariantInUrl(root.dataset.currentVariantId, root);

    fetchCollectionProducts(token, shopDomain, collectionHandle)
      .then(function (products) {
        var config = buildPickerConfig(products, currentContext);
        console.log("[pm-size-color] config", config);

        root.pickerConfig = config;
        console.log("[pm-size-color] root.pickerConfig", root.pickerConfig);
        renderPickerUi(root, config);

        var currentSizeOption = config.sizes.find(function (size) {
          return size.value === config.currentSize;
        });
        ensureVariantInUrl(
          getVariantIdForSize(currentSizeOption, config.currentColorCode),
          root,
        );
      })
      .catch(function (error) {
        root.dataset.pmSizeColorInitialized = "false";
        console.error("[pm-size-color] fetch failed", error);
      });
  }

  function initPickersIn(scope) {
    var roots = (scope || document).querySelectorAll(
      "[data-pm-size-color]:not([data-pm-size-color-initialized='true'])",
    );
    for (var i = 0; i < roots.length; i++) {
      initPicker(roots[i]);
    }
  }

  function initPagePicker() {
    initPickersIn(document);
  }

  // Quick view injects product blocks via DOMParser — those <script> tags never
  // run, so we must init the modal picker when theme fires quickview:loaded.
  document.addEventListener("quickview:loaded", function (evt) {
    var scope = document;
    if (evt && evt.detail && evt.detail.productId) {
      var modal = document.getElementById(
        "QuickShopModal-" + evt.detail.productId,
      );
      if (modal) scope = modal;
    }
    initPickersIn(scope);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPagePicker);
  } else {
    initPagePicker();
  }
})();
